export interface OnboardingGuideInterface {
    steps: OnboardingGuideInterfaceStep[];
}

export interface OnboardingGuideInterfaceStep {
    type: "intro" | "table-of-contents" | "content";
    headline?: string;
    subline?: string;
    text?: string;
    hint?: string;
    machines?: OnboardingGuideInterfaceMachine[];
    mediaElements?: OnboardingGuideInterfaceMediaElement[];
    buttons?: OnboardingGuideInterfaceButton[];
    introButtons?: OnboardingGuideInterfaceButton[];
    progressBarLabel?: string;
    prevButtonLabel?: string;
    nextButtonLabel?: string;
}

export interface OnboardingGuideInterfaceMachine {
    name?: string;
    number?: string;
    imageSrc?: string;
}

export interface OnboardingGuideInterfaceMediaElement {
    type: "image" | "video";
    url: string;
    alt?: string;
    caption?: string;
}

export interface OnboardingGuideInterfaceButton {
    label: string;
    type?: "request" | "close" | "next";
    url?: string;
    variant?: "default" | "primary";
}
